module.exports = __webpack_public_path__ + "img/moon.2d4653c0.svg";